/** Adapts a sync-or-async iterable into a single AsyncIterator, so callers don't have to branch. */
export function toAsyncIterator<T>(source: Iterable<T> | AsyncIterable<T>): AsyncIterator<T> {
  const asyncSource = source as AsyncIterable<T>;
  if (typeof asyncSource[Symbol.asyncIterator] === "function") {
    return asyncSource[Symbol.asyncIterator]();
  }
  return (async function* () {
    yield* source as Iterable<T>;
  })();
}
